
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const BrianeJeanRecuperation = () => {
  const services = [
    "Récupération de métaux",
    "Achat de ferraille",
    "Collecte sur site",
    "Démantèlement",
    "Collecte et traitement des batteries",
    "Collecte et traitement des filtres à huiles",
    "Collecte et traitement des cartouches de fusils"
  ];

  return (
    <SiteDetailPage
      title="Briane Jean Récupération - Achat Métaux Lédergues (12170)"
      description="Briane Jean Récupération à Lédergues - Expert en récupération et achat de métaux ferreux et non ferreux en Aveyron. Spécialiste batteries et filtres à huiles."
      proximityInfo="Service de récupération de métaux dans la région de Lédergues, spécialisé dans l'achat au meilleur prix de tous types de métaux et déchets spéciaux."
      address="Le Pré de Bouques"
      postalCode="12170"
      city="Lédergues"
      phone="05.65.35.12.45"
      email="contactgfe@groupefabre.com"
      website="https://www.briane-jean.fr/"
      services={services}
      coordinates={{ lat: 44.4478, lng: 2.5397 }}
      isMiniSite={true}
    />
  );
};

export default BrianeJeanRecuperation;
